import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
import NextLink from 'next/link';
import { LinkProps } from '@/components/links/types';
import { addPrefixToDataParams } from '@/utils/string';
export function Link(t0) {
  const $ = _c(20);
  let analyticsParam;
  let children;
  let className;
  let rest;
  let testId;
  let title;
  let to;
  if ($[0] !== t0) {
    ({
      analyticsParam,
      children,
      className,
      testId,
      title,
      to,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = analyticsParam;
    $[2] = children;
    $[3] = className;
    $[4] = rest;
    $[5] = testId;
    $[6] = title;
    $[7] = to;
  } else {
    analyticsParam = $[1];
    children = $[2];
    className = $[3];
    rest = $[4];
    testId = $[5];
    title = $[6];
    to = $[7];
  }
  let t1;
  if ($[8] !== className) {
    t1 = mergeClasses("text-blue-500 underline decoration-1 hover:text-blue-800", className);
    $[8] = className;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const fullClassName = t1;
  let t2;
  if ($[10] !== analyticsParam || $[11] !== testId) {
    t2 = addPrefixToDataParams({
      analyticsParam,
      testId,
      prefix: "link"
    });
    $[10] = analyticsParam;
    $[11] = testId;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const dataParams = t2;
  let t3;
  if ($[13] !== children || $[14] !== dataParams || $[15] !== fullClassName || $[16] !== rest || $[17] !== title || $[18] !== to) {
    t3 = <NextLink {...dataParams} {...rest} href={to} title={title} className={fullClassName}>{children}</NextLink>;
    $[13] = children;
    $[14] = dataParams;
    $[15] = fullClassName;
    $[16] = rest;
    $[17] = title;
    $[18] = to;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
}